import React, { useEffect, useState, useContext, useRef } from 'react';
import { Link } from "react-router-dom";
import Layout from '../../../parts/Layout';
import { httpRequest } from '../../../../services/httpService';
import helpers from '../../../../services/helpers';
import Loader from '../../../parts/Loader';
import CategoryFormModal from '../../../modals/CategoryFormModal';
import initTreeView from '../../../../services/initTreeView';
// import TerminalsFormModal from './TerminalsFormModal';
import ProfileContext from '../../../../services/profileContext';
import ProductFinderModal from '../../../modals/ProductFinderModal';
import ProductLookup from '../../../modals/ProductLookup';
import Swal from 'sweetalert2';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import Dropdown from 'react-bootstrap/Dropdown'
import { FaCheckCircle } from "react-icons/fa";
import { Toast } from 'primereact/toast';
 
export default function FeaturedProductsList ({viewer = 'admin', menu = 'featured-products', page_title = "Manage Featured Items"}){
    const {
        account
    } = useContext(ProfileContext);
    const toast = useRef(null);
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [terminal_id, setTerminalID] = useState('');
    const [show_modal, setShowModal] = useState(0);

    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });


    const [selected_member_data, setMemberData] = useState('');
    const [selected_member_id, setMemberID] = useState('');
    const [selected_member_index, setMemberIndex] = useState('');
    const [showItemLookup, setShowItemLookup] = useState(false);

    const [refetchOnSelect, setRefetchOnSelect] = useState('');

    useEffect(() => {
        initTreeView()
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            "search": search_key
        })
    }, [datatable_state]);

    function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&store_id=${helpers.getStoreID()}&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.createUrl('V1/manage/item/featured-product'+filter)
        //const url = helpers.createPosUrl('terminals'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setRecordData(res)
                setLoading(0)
                displayDataTable(res)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete Product'
        if(ids.length > 1){
            title = 'Delete Categories'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(id){
        const url = helpers.createPosUrl('terminals/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function toggleFeaturedPorduct(data){
        //console.log('product_variant_id', data.product_variant_id)
        setLoading(1)
        const url = helpers.createUrl('V1/manage/item/featured-product')
        httpRequest(url, 'POST', {
            postdata: {
                "store_id": helpers.getStoreID(),
                "product_variant_id": data.product_variant_id,
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList()
                setRefetchOnSelect(Math.random() * 100)
                toast.current.show({severity:'success', detail:res.message, life: 3000});
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                //setSelectedItems([])

                toast.current.show({severity:'error', detail:err.message, life: 3000});
            }); 
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="product_name" header="Name" body={({product_variant_name, product_name}) => product_variant_name !== 'Generic' ? `${product_name} (${product_variant_name})` : `${product_name}` } />
                <Column field="product_code" header="SKU" />
                <Column field="category_name" header="Category" />
                <Column className="text-right" body={(data) => data.is_featured && (<button type="button" className="btn btn-sm btn-danger" onClick={() => toggleFeaturedPorduct(data)} style={{ maxWidth: '100px' }}><i className="fas fa-trash mr-2" />Remove</button>)} />
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item 
                                key="edit" 
                                onClick={(e) => editForm(data.id)}
                                className={helpers.checkPermissions(['superAdmin', 'portEdit'], account?.permissions) ? 'text-dark' : 'secondary'}
                                disabled={!helpers.checkPermissions(['superAdmin', 'portEdit'], account?.permissions)}
                            ><i className="fas fa-pencil-alt mr-2" />Edit</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item 
                                key="delete" 
                                className={helpers.checkPermissions(['superAdmin', 'portDelete'], account?.permissions) ? 'text-danger' : 'text-secondary'}
                                disabled={!helpers.checkPermissions(['superAdmin', 'portDelete'], account?.permissions)}
                                onClick={(e) => triggerAction(data, 'single-delete')}
                            ><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)
    }
    
    function addForm(e){
        setTerminalID('')
        setShowModal(1)
    }
    function editForm(id){
        setShowModal(1)
        setTerminalID(id)
    }

    function handleSave(){
        fetchDataList()
    }

    return (
        <>
        
        <ProductLookup 
            is_show={showItemLookup} 
            setShow={setShowItemLookup}  
            handleSelect={toggleFeaturedPorduct} 
            mode="featured-product"
        />

        <Toast ref={toast} position="top-center" />
        
        <Layout page_title={page_title} menu={menu}>

            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-0">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <InputText className="w-100" placeholder="Search" onChange={search} />
                                    </div>
                                    <div className="col-lg-9  d-flex align-items-center justify-content-end">
                                        <div className='d-flex justify-content-end py-2'>
                                            {selected_items.length ?
                                            <Dropdown className='mr-3'>
                                                <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item 
                                                        key="delete" 
                                                        className={helpers.checkPermissions(['superAdmin', 'portDelete'], account?.permissions) ? 'text-danger' : 'text-secondary'}
                                                        disabled={!helpers.checkPermissions(['superAdmin', 'portDelete'], account?.permissions)}
                                                        onClick={(e) => triggerAction(selected_items)}
                                                    ><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> : ''}
                                            <button type='button' className='btn btn-primary float-rights' onClick={() => setShowItemLookup(true)} disabled={!helpers.checkPermissions(['superAdmin', "inventoryView", "inventoryCreate", "inventoryEdit"], account?.permissions)}><i className="fas fa-plus-circle mr-2" />Add Item</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                { data_table }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}